import { createContractClient } from './lib/api-client';
import { userRoutes } from '@contracts/account/user';

export const userApi = createContractClient(userRoutes);
